import { createContext, useContext, useEffect, useState } from 'react';

const CompCtx = createContext(null);
const KEY = 'compare_v1';
const MAX = 4;

export const CompareProvider = ({ children }) => {
  const [ids, setIds] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch { return []; }
  });
  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(ids)); }, [ids]);

  const toggle = (pid) => {
    setIds((prev) => {
      if (prev.includes(pid)) return prev.filter((x) => x !== pid);
      if (prev.length >= MAX) return prev;
      return [...prev, pid];
    });
  };
  const remove = (pid) => setIds((prev) => prev.filter((x) => x !== pid));
  const clear = () => setIds([]);
  const has = (pid) => ids.includes(pid);

  return (
    <CompCtx.Provider value={{ ids, toggle, remove, clear, has, count: ids.length, max: MAX }}>
      {children}
    </CompCtx.Provider>
  );
};

export const useCompare = () => useContext(CompCtx);
